/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useContext, useEffect} from 'react';
import Teams from '../../utils/api/Teams';
import {config} from '../../utils/config/config';
import {ARMcontext} from '../../utils/context/context';
import Img8 from '../../assets/images/enter work CS.png';
import {useInputValue} from '../../utils/hooks/useInputValue';
import {EmptyCard, EmptyImage, LargeButton} from '../../components';
import {SideBarTitle, SideBarSubtitle, RadiosContainer, SideBar} from '../../components/sideBar/styles';
import {Navbar, TableEditDelete, FluidContainer, PowerDropdown, Radio, InputComponent, InputArea, InputDate} from '../../components';

const DefaultPlayers = [
  {title: 'All Players', lenght: 50},
  {title: 'Pitchers', lenght: 20},
  {title: 'Catchers', lenght: 30},
];

export default () => {
  const {teamMemo} = useContext(ARMcontext);
  const [radio, useRadio] = useState<any>({one: true, two: false});
  const [eventType, useEventType] = useState<any>();
  const [team, useTeam] = useState<any>(teamMemo[0]);
  const [date, setDate] = useState(new Date());
  const [players, usePlayers] = useState<any>(DefaultPlayers);
  const [player, usePlayer] = useState<any>(players[0]);
  const [workLoads, useWorkLoads] = useState<Array<any>>([]);
  const note = useInputValue('');
  const pitches = useInputValue('');
  const inningPitched = useInputValue('');
  const inningPitchedTwo = useInputValue('');
  const strikes = useInputValue('');
  const balls = useInputValue('');
  const stress = useInputValue('');

  const TEAMS = new Teams();
  const workloadMainHead = [
    {
      title: 'LATEST OUTING',
      colSpan: '6',
    },
    {
      title: 'SEASON',
      colSpan: '3',
    },
  ];
  const workloadTableHead = [
    {
      title: 'PLAYERS',
      colSpan: '1',
      examType: ['player', 'fullName'],
    },
    {
      title: 'DATES',
      colSpan: '1',
      examType: ['date'],
    },
    {
      title: 'EVENT',
      colSpan: '1',
      examType: ['eventType'],
    },
    {
      title: 'PITCHES',
      colSpan: '1',
      examType: ['pitches'],
    },
    {
      title: 'INNINGS',
      colSpan: '1',
      examType: ['innings'],
    },
    {
      title: 'STRIKE %',
      colSpan: '1',
      examType: ['percentage_one'],
    },
    {
      title: 'TOTAL INNINGS',
      colSpan: '1',
      examType: ['total_innings'],
      split: [true, 1],
    },
    {
      title: 'AVG. PITCH COUNT',
      colSpan: '1',
      examType: ['avg_pitch'],
      split: [true, 2],
    },
    {
      title: 'STRIKE %',
      colSpan: '1',
      examType: ['percentage_two'],
    },
    {
      title: 'NOTES',
      colSpan: '1',
      examType: ['notes'],
    },
    {
      title: 'EDIT',
      colSpan: '1',
      examType: ['edit'],
    },
    {
      title: 'DELETE',
      colSpan: '1',
      examType: ['delete'],
    },
  ];

  useEffect(() => {
    FetchPlayers();
  }, [team]);
  useEffect(() => {
    usePlayer(players[0]);
  }, [players]);
  useEffect(() => {
    if (radio.one) {
      useEventType('Game');
    }
    if (radio.two) {
      useEventType('Trainning');
    }
  }, [radio]);
  function handleDelete(id) {
    useWorkLoads([...workLoads.filter(item => item._id !== id)]);
  }
  function handleEdit(id) {
    console.log('edit record', id);
  }
  function HandleRadiosButtons(e: any) {
    if (e.target.id === 'Trainning') {
      useRadio({one: false, two: true});
    } else {
      useRadio({one: true, two: false});
    }
  }
  function ChangeTeam(selectedTeam: any) {
    useTeam(selectedTeam);
  }
  function ChangePlayer(selectedOption: any) {
    usePlayer(selectedOption);
  }
  async function FetchPlayers(): Promise<void> {
    const resPlayers = await TEAMS.GetPlayersOfAteam(true, 1, team._id);
    if (resPlayers.data) {
      const playersFetched = await resPlayers?.data['player-teams']?.map(player => player.player);
      usePlayers(playersFetched);
    }
  }
  function completeSession() {
    console.log(workLoads);
  }
  function addData() {
    const form = {
      player: player,
      team: team,
      date: date,
      eventType: eventType,
      pitches: pitches.value || 0,
      percentage_one: '43%',
      percentage_two: '90%',
      avg_pitch: '32',
      strikes: strikes || 0,
      balls: balls || 0,
      stressInnning: stress,
      innings: inningPitched.value || 0,
      total_innings: parseInt(inningPitchedTwo.value) + parseInt(inningPitched.value) || 0,
      notes: note.value,
      _id: player._id + workLoads.length + '_',
    };

    useWorkLoads([...workLoads, form]);
    useRadio({one: true, two: false});
    useEventType('');
    note.HandleValue('');
    pitches.HandleValue('');
    inningPitched.HandleValue('');
    inningPitchedTwo.HandleValue('');
    strikes.HandleValue('');
    balls.HandleValue('');
    stress.HandleValue('');
  }

  return (
    <>
      <Navbar />
      {config.blocked ? (
        <div style={{display: 'flex', marginTop: '10px', flexDirection: 'column', alignItems: 'center'}}>
          <EmptyCard />
          <EmptyImage src={Img8} />
        </div>
      ) : (
        <FluidContainer>
          <div style={{display: 'flex', justifyContent: 'center', margin: '40px 0px 0px 0px'}}>
            <div data-cy="workloads_sidebar">
              <SideBar>
                <div style={{height: '100%', margin: '0px 43px 0px 45px'}}>
                  <SideBarTitle>ENTER WORKLOADS</SideBarTitle>
                  <div data-cy="teams-dropdown">
                    <PowerDropdown
                      primaryTitle={team?.name}
                      badge={team?.initials || team?.badge}
                      picture={team?.picture}
                      colorBadge={team?.color}
                      search={true}
                      onClick={ChangeTeam}
                      dataArray={teamMemo}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <div data-cy="players-dropdown">
                    <SideBarSubtitle>Player</SideBarSubtitle>
                    <PowerDropdown
                      primaryTitle={player?.fullName || 'All Players'}
                      visibleLenght={players?.lenght}
                      picture={player?.picture || 'http://52.6.174.117:4000/file/c84e78e1-be0a-423a-94ba-220a5d7cd4efdefaultAvatar.png'}
                      search={true}
                      onClick={ChangePlayer}
                      dataArray={players}
                      mPadding="4px 0 4px 10px"
                    />
                  </div>
                  <div style={{display: 'block'}} data-cy="date-input">
                    <SideBarSubtitle>Date</SideBarSubtitle>
                    <InputDate date={date} setDate={setDate} />
                  </div>

                  <SideBarSubtitle>Event</SideBarSubtitle>
                  <RadiosContainer onChange={HandleRadiosButtons} data-cy="radio-panel">
                    <Radio title="Game" name="tableInfo" id="Game" checked={true} dynamicActive={radio?.one} />
                    <Radio title="Trainning" name="tableInfo" id="Trainning" checked={false} dynamicActive={radio?.two} />
                  </RadiosContainer>

                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}} data-cy="input-panel">
                    <div style={{width: '45%'}}>
                      <SideBarSubtitle>
                        <span style={{color: 'red', position: 'relative', left: '-5px'}}>*</span>Total Pitches
                      </SideBarSubtitle>
                      <InputComponent dynamicSearch={pitches} animateWidth={'70px'} />
                    </div>
                    <div style={{width: '65%'}}>
                      <SideBarSubtitle>
                        <span style={{color: 'red', position: 'relative', left: '-5px'}}>*</span>Innings Pitched
                      </SideBarSubtitle>
                      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <InputComponent dynamicSearch={inningPitched} animateWidth={'70px'} />
                        <InputComponent dynamicSearch={inningPitchedTwo} animateWidth={'70px'} />
                      </div>
                    </div>
                  </div>

                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                    <div style={{width: '45%'}}>
                      <SideBarSubtitle># Of Strikes</SideBarSubtitle>
                      <InputComponent dynamicSearch={strikes} animateWidth={'70px'} />
                    </div>
                    <div style={{width: '65%'}}>
                      <SideBarSubtitle># Of Balls</SideBarSubtitle>
                      <InputComponent dynamicSearch={balls} animateWidth={'70px'} />
                    </div>
                  </div>
                  <SideBarSubtitle>Stress Innings (23+ pitches)</SideBarSubtitle>
                  <InputComponent dynamicSearch={stress} animateWidth={'70px'} />

                  <SideBarSubtitle>Note (optional)</SideBarSubtitle>
                  <div data-cy="note-input">
                    <InputArea dynamicSearch={note} placeholder={'Input Text'} row={15} />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    margin: '25px 0px 0px 0px',
                  }}>
                  <LargeButton
                    title={'Add Data'}
                    callback={() => addData()}
                    lColor={'#fff'}
                    rColor={'linear-gradient(180deg, #1A88FF 0%, #007AFF 100%)'}
                    fColor="#ffffff"
                    bColor="#0086FF"
                    lMargin="0 0px"
                    rMargin="0 60px"
                    xMargin="0"
                  />
                </div>
              </SideBar>
            </div>
            <div style={{width: 'min-content'}}>
              <div data-cy="workloads_table">
                <TableEditDelete
                  dataTableContent={workLoads}
                  dataMainHead={workloadMainHead}
                  dataTableHead={workloadTableHead}
                  onDelete={handleDelete}
                  onEdit={handleEdit}
                />
              </div>
              <div data-cy="session_complete" style={{display: 'flex', justifyContent: 'flex-end'}}>
                <LargeButton
                  title={'Session Complete'}
                  callback={() => completeSession()}
                  lColor={'#fff'}
                  rColor={'linear-gradient(180deg, #FF3A1F 0%, #FF2608 100%)'}
                  fColor="#ffffff"
                  bColor="#FF472D"
                  lMargin="0 0px"
                  rMargin="0 60px"
                  xMargin="0"
                />
              </div>
            </div>
          </div>{' '}
        </FluidContainer>
      )}
    </>
  );
};
